import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { Button } from 'antd';

const ErrorDialog = ({ storeName, isOpen, title, errors, onClose }) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description">
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      {errors.map((error) => (
        <DialogContentText key={error.path}>
          {T.translate(`${storeName}.errorFields.${error.path.replace(/\[.\]/g, '')}`)}{' '}
          {T.translate(`error.${error.result}`)}
        </DialogContentText>
      ))}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} type="primary">
        {T.translate('inspectionJobDetailWorkspace.close')}
      </Button>
    </DialogActions>
  </Dialog>
);

ErrorDialog.defaultProps = {
  title: '',
  errors: [],
};

ErrorDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  storeName: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func.isRequired,
};

export default ErrorDialog;
